<script setup>

import { useRoute, useRouter } from "vue-router";
import { useActiveDeviceRenderStore } from "@/stores/activeDeviceRender";
import HttpStatusCodeBadge from "@/components/HttpStatusCodeBadge.vue";
import { useWebsiteStore } from "@/stores/website";
import { ref } from "vue";

const activeDeviceRender = useActiveDeviceRenderStore();
const router = useRouter()
const route = useRoute()
const props = defineProps({
  issues: Object,
  id: String,
  icon: {type: String, default: "fa fa-square"},
  title: String,
  staticTitle: {type: Boolean, default: false},
});
const websiteStore = useWebsiteStore();

function isOpen() {
  const id = `details_button_${props.id}`;
  const el = document.getElementById(id);
  if (!el) return;
  let r = el.getAttribute('aria-expanded');
  return r === 'true'
}

async function ignoreIssue(issue) {
  let q = {};
  console.log(issue)
  Object.assign(q, route.query);
  q[props.id] = null
  await router.push({query: q})
  issue['category'] = issue['category'] || issue['reason']
  await websiteStore.ignoreIssue(issue, activeDeviceRender.page.externalId)

}

function toggleProofreadingAccordion(issue) {

  if (!isOpen()) {
    router.replace({query: { 'section': 'audit'}})
  } else {
    router.replace({query: {[props.id]: issue.id, 'i': 1,  'section': 'audit'}})
  }

}

const issue = ref({})

function issueLabel(issue) {
  if (issue.label) {
    return issue.label;
  }
  return 'abc'
}

const level = ref('warning')
if (props.issues.length > 0) {
  if (props.issues[0].priority === 'high') {
    level.value = 'error'
  } else if (props.issues[0].priority === 'medium') {
    level.value = 'warning'
  } else if (props.issues[0].priority === 'low') {
    level.value = 'suggestion'
  }
}

const issuesAccordionId = `id-audit-issue-list`
</script>

<template>
  <div class="list-group-item" v-if="issues.length > 0">

    <div :class="{'issue-header-hover': 0}">
      <div class="issue-header collapsed ps-2" data-bs-toggle="collapse"
           :data-bs-target="`#details_copy_${id}`" :id="`details_button_${id}`"

           aria-expanded="false" @click="toggleProofreadingAccordion(issues[0])">
        <div class="d-flex align-items-center flex-grow-1 issue-text text-truncate">
          <span class="me-1 issue-icon-fixed-width" :class="{[`proofreading-text-${level}`]: 1, [icon]: 1}"></span>
          <strong v-if="staticTitle" class="issue-type-header">{{ title }}:</strong>
          <strong v-else class="issue-type-header">{{ issues.length }} {{ title }}{{
              issues.length > 1 ? 's' : ''
            }}:</strong>
          <span class="text-truncate text-muted" v-if="issue.current_copy">"{{
              issue.current_copy
            }}"</span>
        </div>
        <i class="fa-solid fa-chevron-right chevron"></i>
      </div>
    </div>
    <div :id="`details_copy_${id}`" class="collapse" :data-bs-parent="`#${issuesAccordionId}`">
      <div class="detailvs ">
        <ul class="list-group list-group-flush ">
          <div class="list-group-item list-group-item-action issue-item p-3"
               v-for="issue in issues || []" :key="issue.id"
               :class="{'issue-selected': issue.id === route.query[id]}, [issue.classes]"
          >
            <div v-if="issue.id === 'aspect_ratio'" class="hstack gap-3 pb-1">
              <div v-if="issue.preview" :style="issue.preview.style">

              </div>
              <div>
                Incorrect Aspect Ratio<br>
                <small class="text-muted">{{ issue.description }}</small>
              </div>
            </div>
            <div v-else-if="issue.id === 'console_error'">
              <div class="issue-console-error"><span
                  class=" badge bg-danger">{{ (issue.occurrences || []).length }}</span> {{ issue.text }}
              </div>
            </div>
            <div v-else-if="issue.category === 'technical.console_error'">
              <div class="issue-console-error"><span
                  class=" badge bg-warning">{{ (issue.occurrences || []).length }}</span> {{ issue.text }}
              </div>
            </div>
            <div v-else-if="issue.category === 'technical.broken_resource'">
              <small class="text-muted overflow-text-ellipsis">

                <http-status-code-badge :status-code="`${issue.status}`"/>&nbsp;
                <a target="_blank" title="External Link"
                   :href="issue.url" class="external-link-plain"> {{ issue.url }}</a>

              </small>
            </div>
            <div v-else class="overflow-text-ellipsis me-4">
              <small class="text-muted overflow-text-ellipsis" v-linkify>
                <http-status-code-badge v-if="issue.showStatusCode" :status-code="issue.statusCode"/>
                {{ issue.description }}</small>
            </div>
            <template v-if="issue.occurrences && issue.occurrences.length > 0 || issue.devices?.length">
              <template v-if="issue.devices && activeDeviceRender.deviceRenders.length === issue.devices.length">

                <small class="text-muted">
                  <router-link :to="{ query: {[id]: issue.id, 'i': 1, 'section': 'audit'}, force: true}"> <span
                      class="fa fa-magnifying-glass"></span> Locate on page
                  </router-link>
                  <small
                      v-if="issue.occurrences.length > 1">({{ issue.occurrences.length }}
                    occurrences)</small>
                </small>

              </template>
              <template v-else>
                <router-link v-for="device in issue.devices || []"
                             :to="{params: {deviceId: device.id}, query: {[id]: issue.id, 'i': 1,  'section': 'audit'}, force: true}"> <span

                    class="badge bg-secondary me-1" style="font-size:11px" title="Locate on page"><span
                    class="fa fa-magnifying-glass"></span> {{ device.name }}</span>
                </router-link>
              </template>
            </template>
            <div v-if="1" class="dropdown dropdown-menu-sm-end" style="float:right;top:0px;margin-right: 0px;">
              <a href="#" class="text-secondary dropdown-toggle" role="button" data-bs-toggle="dropdown"
                 aria-expanded="false" title="Options" aria-label="Options menu">
                <span class="fa fa-gear text-muted"></span>
              </a>
              <ul class="dropdown-menu dropdown-menu-end dropdown-menu-md text-small">
                <li>
                  <a class="dropdown-item" href="" @click.prevent="ignoreIssue(issue)">
                    <span class="fa fa-minus-circle me-2"></span> Ignore this Issue.</a>
                </li>

              </ul>
            </div>

            <a v-if="0 || issue.ignoreButton && issue.ignoreButton.show" style="float:right" href="" class="text-muted"
               title="Ignore this issue"><span
                class="fa fa-eye-slash" @click.prevent="ignoreIssue(issue)"></span></a>
          </div>
        </ul>


      </div>
    </div>


  </div>
</template>

<style scoped>
.issue-icon-fixed-width {
  width: 20px;
  display: inline-block;
  text-align: center;
}

</style>